var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyToUseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.905,
    height: 62.984,
    viewBox: "0 0 58.905 62.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "easy-to-use-1",
    transform: "translate(-65.067 -42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    className: "cls-1",
    d: "M113.522,205.16H84.749a7.884,7.884,0,0,1-5.726-2.29L67.429,190.989a7.949,7.949,0,0,1,0-11.309,7.62,7.62,0,0,1,11.165,0l.286.286V155.918a6.567,6.567,0,0,1,6.585-6.585,6.69,6.69,0,0,1,6.728,6.585v9.877a7.025,7.025,0,0,1,9.161,1.288,6.663,6.663,0,0,1,5.3-2.434,6.74,6.74,0,0,1,6.728,6.3,7.2,7.2,0,0,1,3.865-1.145,6.6,6.6,0,0,1,6.728,6.585v18.466a10.775,10.775,0,0,1-10.45,10.307ZM84.749,202.3h28.629a7.455,7.455,0,0,0,7.3-7.444V176.245a3.821,3.821,0,0,0-3.865-3.722,3.73,3.73,0,0,0-3.865,3.722h-2.863v-5.153a3.821,3.821,0,0,0-3.865-3.722,3.73,3.73,0,0,0-3.865,3.722H99.493a3.821,3.821,0,0,0-3.865-3.722c-2.147,0-3.436,1.718-3.436,3.865H89.33V155.918a3.868,3.868,0,0,0-7.73,0v30.92l-5.153-5.3a5.012,5.012,0,0,0-7.157,0,5.184,5.184,0,0,0,0,7.3l11.595,11.881a5.8,5.8,0,0,0,3.865,1.575Z",
    transform: "translate(0 -99.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    className: "cls-1",
    d: "M196.433,58.413A1.352,1.352,0,0,1,195,56.982c0-6.3-4.867-11.452-10.736-11.452s-10.736,5.153-10.736,11.452a1.431,1.431,0,1,1-2.863,0c0-7.873,6.155-14.315,13.6-14.315s13.6,6.442,13.6,14.315a1.352,1.352,0,0,1-1.431,1.431Zm3.292,24.335a1.352,1.352,0,0,1-1.431-1.431V69.865a1.431,1.431,0,1,1,2.863,0V81.316A1.352,1.352,0,0,1,199.725,82.748Zm-10.45,0a1.352,1.352,0,0,1-1.431-1.431V69.865a1.431,1.431,0,1,1,2.863,0V81.316A1.352,1.352,0,0,1,189.275,82.748Zm21.042,0a1.352,1.352,0,0,1-1.431-1.431V74.159a1.431,1.431,0,1,1,2.863,0v7.157A1.434,1.434,0,0,1,210.318,82.748Z",
    transform: "translate(-98.514)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyToUseWhite);
export default __webpack_public_path__ + "static/media/easy-to-use-white.1cb41f12bfcd7d67d2d77b999226acc7.svg";
export { ForwardRef as ReactComponent };